<template>
  <div class="wrong_question_box">
    <div class="flex FlexBetween Flexalign total_count">
      <div class="">
        共有<span class="text_active list_total_count">{{ listTotal }}</span>道错题
      </div>
      <div class="text_active">错题测试 ></div>
    </div>
    <div class="top_box mar_top_20 flex Flexjustify flexcolumn">
      <div class="filter_box flex">
        <div>学段:</div>
        <div class="flex FlexWrap flex-1">
          <div class="area_info cursor_pointer" :class="[listQuery.stageId == '' ? 'active_area_info' : '']"
            @click="selectStage('')">
            不限
          </div>
          <div v-for="(item, index) in stageList" :key="index" class="area_info cursor_pointer"
            :class="[listQuery.stageId == item.stageId ? 'active_area_info' : '']" @click="selectStage(item.stageId)">
            {{ item.stageName }}
          </div>
        </div>
      </div>
      <div class="filter_box flex">
        <div>年级:</div>
        <div class="flex FlexWrap flex-1">
          <div class="area_info cursor_pointer" :class="[listQuery.gradeId == '' ? 'active_area_info' : '']"
            @click="selectGrade('')">
            不限
          </div>
          <div v-for="(item, index) in gradeList" :key="index" class="area_info cursor_pointer"
            :class="[listQuery.gradeId == item.gradeId ? 'active_area_info' : '']" @click="selectGrade(item.gradeId)">
            {{ item.gradeName }}
          </div>
        </div>
      </div>
      <div class="filter_box flex">
        <div>学科:</div>
        <div class="flex FlexWrap flex-1">
          <div class="area_info cursor_pointer" :class="[listQuery.subjectId == '' ? 'active_area_info' : '']"
            @click="selectSubjet('')">
            不限
          </div>
          <div v-for="(item, index) in subjectList" :key="index" class="area_info cursor_pointer"
            :class="[listQuery.subjectId == item.subjectId ? 'active_area_info' : '']"
            @click="selectSubjet(item.subjectId)">
            {{ item.subjectName }}
          </div>
        </div>
      </div>
    </div>
    <div class="question_list">
      <wrongQuestionList ref="wrongQuestionList"></wrongQuestionList>
    </div>
    <div class="pagination_box mar_top_10 flex FlexjustifyEnd" v-if="listTotal > listQuery.pageSize">
      <el-pagination background layout="prev, pager, next" :total="listTotal" @current-change="handleCurrentChange" />
    </div>
    <moe-empty url="moe_empty_bg_img.png" emptyText="暂无错题集" v-if="listTotal == 0"></moe-empty>
  </div>
</template>

<script>
import { mapState } from "vuex";
import wrongQuestionList from "./wrongQuestionList.vue";
export default {
  name: "GjkcH5WrongQuestion",
  computed: {
    ...mapState({
      stageList: (state) => state.filter.stageList,
    }),
  },
  components: {
    wrongQuestionList,
  },

  data() {
    return {
      listTotal: 0,
      wrongQuestionList: [],
      listQuery: {
        courseId: "",
        chapterId: "",
        gradeId: "",
        subjectId: "",
        stageId: "",
        page: 1,
        pageSize: 10,
      },
      gradeList: [],
      subjectList: [],
      courseList: [],
    };
  },

  mounted() {
    this.gradeList = this.$store.state.filter.gradeList;
    this.subjectList = this.$store.state.filter.subjectList;
    this.getWrongQuestionList();
  },

  methods: {
    // 选择学段
    selectStage(value) {
      this.listQuery.stageId = value;
      if (value == "") {
        this.gradeList = this.$store.state.filter.gradeList;
      } else {
        this.gradeList = this.$store.state.filter.gradeList.filter(
          (item) => item.stageId == value
        );
      }
      this.$Api.common
        .getSubject({ stageId: this.listQuery.stageId })
        .then((res) => {
          this.subjectList = res.data.data;
        })
        .catch((err) => {
          // this.$Dialog.toast(err.data.message, { type: "error" });
          console.log(err);
        });
    },
    // 选择年级
    selectGrade(value) {
      this.listQuery.gradeId = value;
    },
    // 选择学科
    selectSubjet(value) {
      this.listQuery.subjectId = value;
    },
    getWrongQuestionList() {
      this.$Api.learning
        .getWrongQuestionListPage(this.listQuery)
        .then((res) => {
          this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
          this.wrongQuestionList = res.data.data.list.map((item) => {
            return { ...item, isExpend: true, isShowAnalysis: false };
          });
          this.wrongQuestionList.forEach(item => {
            item.questionContext = this.$Tools.jsonDecode(item.questionContext)
          })
          this.$refs.wrongQuestionList.wrongQuestionList = this.wrongQuestionList;
        })
        .catch(() => { });
    },
    handleCurrentChange(value) {
      this.listQuery.page = value;
      this.getWrongQuestionList();
    },
  },
};
</script>

<style lang="scss" scoped>
.wrong_question_box {
  padding: 20px 0;

  .total_count {
    font-size: 18px;
    color: #111111;

    .list_total_count {
      font-weight: 600;
    }
  }

  .top_box {
    width: 100%;
    box-sizing: border-box;
    background: #f5f6f8;
    border-radius: 10px;
    padding: 15px;

    .filter_box {
      //   width: $pageMainWidth;
      line-height: 32px;

      // margin-bottom: 10px;
      .area_info {
        padding: 0 11px;
        box-sizing: border-box;
        margin-left: 10px;
      }

      .active_area_info {
        color: #13d6aa;
      }

      .filter {
        width: 95px;
        height: 32px;
        border-radius: 5px;
        border: 1px solid #e1e1e1;
        line-height: 32px;

        .filter_icon {
          width: 18px;
          height: 18px;
        }
      }
    }

    .sublist_box {
      margin-top: 10px;

      .opacity_box {
        opacity: 0;
      }

      .area_box {
        margin-left: 10px;
        height: 45px;
        background: #f3f3f3;
        border-radius: 10px;
      }

      .area_info {
        padding: 0 11px;
        box-sizing: border-box;
        margin-left: 10px;
        line-height: 45px;
      }

      .more_box {
        height: 45px;
        margin-right: 10px;
      }

      .filter_icon {
        width: 18px;
        height: 18px;
      }
    }
  }

  .question_list {
    width: 100%;
  }
}
</style>
